import * as Yup from "yup";

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const invalidEmailMessage = "Invalid email";

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(invalidEmailMessage)
    .required(invalidEmailMessage)
    .matches(emailRegex, invalidEmailMessage)
});
